/* bcb-collection.js
   Progressive enhancement for the collection / search listing.
   The form is a real GET -- this file only decides when it submits,
   opens the mobile drawer, and optionally appends the next page.
   Nothing here invents filter URLs; Shopify already minted them. */

(function () {
  const root = document.querySelector('[data-bcb-plp]');
  if (!root) return;

  const form = root.querySelector('[data-bcb-form]');
  const drawer = root.querySelector('[data-bcb-drawer]');
  const backdrop = root.querySelector('[data-bcb-backdrop]');
  const openBtn = root.querySelector('[data-bcb-drawer-open]');
  const closeBtn = root.querySelector('[data-bcb-drawer-close]');
  const mq = window.matchMedia('(max-width: 989px)');

  let lockCount = 0;
  let lastFocus = null;

  function isMobile() {
    return mq.matches;
  }

  function lockScroll() {
    lockCount += 1;
    if (lockCount !== 1) return;
    const gap = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
  }

  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount !== 0) return;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function openDrawer() {
    if (!drawer || !isMobile()) return;
    lastFocus = document.activeElement;
    drawer.dataset.open = 'true';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    if (backdrop) backdrop.hidden = false;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    lockScroll();
    const focusable = drawer.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.dataset.open = 'false';
    drawer.removeAttribute('role');
    drawer.removeAttribute('aria-modal');
    if (backdrop) backdrop.hidden = true;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.dataset.open === 'true') {
      closeDrawer();
    }
  });

  mq.addEventListener('change', function () {
    if (!isMobile()) closeDrawer();
  });

  function buildUrl() {
    if (!form) return window.location.href;
    const url = new URL(form.action, window.location.origin);
    const data = new FormData(form);
    data.forEach(function (value, key) {
      if (value === '' || value == null) return;
      url.searchParams.append(key, value);
    });
    url.searchParams.delete('page');
    return url.toString();
  }

  function applyFilters() {
    window.location.assign(buildUrl());
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });
    form.addEventListener('change', function (event) {
      if (isMobile()) return;
      if (event.target && event.target.matches('[data-bcb-facet-find]')) return;
      applyFilters();
    });
  }

  root.querySelectorAll('[data-bcb-facet-more]').forEach(function (button) {
    button.addEventListener('click', function () {
      const facet = button.closest('[data-bcb-facet]');
      if (facet) facet.classList.add('is-expanded');
      button.hidden = true;
    });
  });

  root.querySelectorAll('[data-bcb-facet-find]').forEach(function (input) {
    input.addEventListener('input', function () {
      const query = input.value.trim().toLowerCase();
      const facet = input.closest('[data-bcb-facet]');
      if (!facet) return;
      facet.classList.add('is-expanded');
      const more = facet.querySelector('[data-bcb-facet-more]');
      if (more) more.hidden = true;
      facet.querySelectorAll('.bcb-facet__value').forEach(function (row) {
        const label = row.querySelector('.bcb-facet__choice-label');
        const text = label ? label.textContent.toLowerCase() : '';
        row.classList.toggle('is-hidden', query !== '' && text.indexOf(query) === -1);
      });
    });
  });

  /* Swap the SEO pager for Load more only when a next URL exists.
     Removing the <ol> (not hiding it) is what prevents the dual-control
     bug — a display:none list is still announced to assistive tech. */
  const pager = root.querySelector('[data-bcb-pagination]');
  if (pager) {
    const nextUrl = pager.getAttribute('data-next-url');
    const pages = pager.querySelector('[data-bcb-pages]');

    if (nextUrl && pages) {
      pages.remove();

      const loadMore = document.createElement('button');
      loadMore.type = 'button';
      loadMore.className = 'bcb-plp__more';
      loadMore.setAttribute('data-bcb-load-more', '');
      loadMore.setAttribute('data-next-url', nextUrl);
      loadMore.textContent = 'Load more';
      pager.setAttribute('aria-label', 'Load more products');
      pager.appendChild(loadMore);

      loadMore.addEventListener('click', function () {
        const href = loadMore.getAttribute('data-next-url');
        const sectionId = root.getAttribute('data-section-id');
        if (!href || !sectionId) return;

        loadMore.disabled = true;
        const url = new URL(href, window.location.origin);
        url.searchParams.set('section_id', sectionId);

        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const incoming = doc.querySelector('[data-bcb-grid]');
            const grid = root.querySelector('[data-bcb-grid]');
            if (incoming && grid) {
              while (incoming.firstChild) grid.appendChild(incoming.firstChild);
            }

            const nextCount = doc.querySelector('[data-bcb-count]');
            root.querySelectorAll('[data-bcb-count]').forEach(function (node) {
              if (nextCount) node.textContent = nextCount.textContent;
            });

            /* Next page's nav carries data-next-url only while another
               page remains — absence means we are done; remove the
               button entirely so it cannot linger disabled. */
            const nextPager = doc.querySelector('[data-bcb-pagination]');
            const following = nextPager && nextPager.getAttribute('data-next-url');
            if (following) {
              loadMore.setAttribute('data-next-url', following);
              loadMore.disabled = false;
            } else {
              loadMore.remove();
              if (!pager.querySelector('[data-bcb-load-more], [data-bcb-pages]')) {
                pager.remove();
              }
            }

            history.pushState({}, '', href);
          })
          .catch(function () {
            window.location.assign(href);
          });
      });
    }
  }

  window.addEventListener('popstate', function () {
    window.location.reload();
  });
})();

/* Merch rails live in a sibling section, so this IIFE cannot hang
   off `[data-bcb-plp]`. A silent overflow of eight 28% tracks is
   what the owner read as a broken slider — the buttons and the
   is-fit class are what make the two states honest. */
(function () {
  if (window.__bcbMerchRails) return;
  window.__bcbMerchRails = true;

  function step(scroller) {
    const card = scroller.querySelector(':scope > *');
    if (!card) return 0;
    const styles = getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function bind(rail) {
    const scroller = rail.querySelector('[data-bcb-merch-scroller]');
    const nav = rail.querySelector('[data-bcb-merch-nav]');
    const prev = rail.querySelector('[data-bcb-merch-prev]');
    const next = rail.querySelector('[data-bcb-merch-next]');
    if (!scroller) return;

    function update() {
      const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const atStart = scroller.scrollLeft <= 1;
      const atEnd = scroller.scrollLeft >= max - 1;
      rail.dataset.atStart = atStart ? 'true' : 'false';
      rail.dataset.atEnd = atEnd ? 'true' : 'false';
      if (prev) {
        prev.disabled = atStart;
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (next) {
        next.disabled = atEnd;
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    function layout() {
      const count = scroller.children.length;
      const fit = parseInt(getComputedStyle(rail).getPropertyValue('--bcb-merch-fit'), 10) || 2;
      rail.style.setProperty('--bcb-merch-count', String(count));
      const fits = count <= fit;
      rail.classList.toggle('is-fit', fits);
      if (nav) nav.hidden = fits;
      update();
    }

    function go(dir) {
      scroller.scrollBy({ left: dir * step(scroller), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    scroller.addEventListener('scroll', update, { passive: true });
    scroller.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      }
    });

    window.addEventListener('resize', layout);
    layout();
  }

  document.querySelectorAll('[data-bcb-merch-rail]').forEach(bind);
})();
